import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store";
import { paths } from "@/routes/paths";
import { canAccessAdminResources, isSuperAdmin } from "@/lib/permissions";

export function ProtectedRoute() {
  const location = useLocation();
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);

  if (!token || !user) {
    return <Navigate to={paths.SIGN_IN} state={{ from: location }} replace />;
  }

  if (!canAccessAdminResources(user)) {
    return <Forbidden />;
  }

  return <Outlet />;
}

export function SuperAdminRoute() {
  const user = useAuthStore((s) => s.user);

  if (!isSuperAdmin(user)) {
    return <Navigate to={paths.HOME} replace />;
  }

  return <Outlet />;
}

function Forbidden() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">Sem permissão</h1>
        <p className="text-sm text-muted-foreground">
          Sua conta não tem a permissão <code>admin-resources</code> necessária
          para acessar este app.
        </p>
      </div>
    </div>
  );
}
